module.exports = __webpack_public_path__ + "static/media/oranguhang02.30bfe165.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/oranguhang02.svg
// module id = 586
// module chunks = 19